import React, { FC, useCallback, useMemo, MouseEvent } from 'react'

import {
  EditorState,
  RichUtils,
  Modifier,
} from 'draft-js'

import {
  IconComponentType,
} from '../../types/app'

import {
  ITextEditor_EditorUpdate,
} from '@kaidam/fc-shared/src/types/texteditor'

import ToolbarButton from './ToolbarButton'

interface ToolbarButtonInlineProps {
  style: string,
  title: string,
  className?: string,
  icon: IconComponentType,
  editorState: EditorState,
  setEditorState: ITextEditor_EditorUpdate,
}

const ToolbarButtonInline: FC<React.PropsWithChildren<ToolbarButtonInlineProps>> = ({
  style,
  title,
  className,
  icon,
  editorState,
  setEditorState,
}) => {

  const onClick = useCallback(() => {
    setEditorState(
      RichUtils.toggleInlineStyle(editorState, style)
    )
  }, [
    editorState,
  ])

  const active = useMemo<boolean>(() => {
    if(!editorState || !style) return false
    return editorState.getCurrentInlineStyle().has(style)
  }, [
    editorState,
    style,
  ])

  return (
    <ToolbarButton
      title={ title }
      className={ className }
      icon={ icon }
      active={ active }
      onClick={ onClick }
    />
  )
}

export default ToolbarButtonInline